/** @format */

import {
	AppProductReviewState,
	ReviewSummary,
	selectProductIncludedInformation,
	selectProductReviewSummary
} from '@product-reviews/data-access';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { ReviewsPercentageComponent } from '../reviews-percentage/reviews-percentage.component';
import { ReviewStarsComponent } from '../review-stars/review-stars.component';
import { StarRatingNumberPipe } from '../pipes/star-rating-number.pipe';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'product-reviews-summary',
	templateUrl: './reviews-summary.component.html',
	styleUrl: './reviews-summary.component.scss',
	imports: [CommonModule, StarRatingNumberPipe, ReviewsPercentageComponent, ReviewStarsComponent]
})
export class ReviewsSummaryComponent implements OnInit, OnDestroy {
	rating: number;
	count: number;
	productReviewed$ = this.store.select(selectProductIncludedInformation);
	reviewSummary: ReviewSummary;
	private UNSUBSCRIBE$ = new Subject<void>();
	starsOptions = {
		width: '32px',
		height: '32px'
	};

	constructor(private store: Store<AppProductReviewState>) {}

	ngOnInit() {
		this.store
			.select(selectProductReviewSummary)
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe((reviewSummary: ReviewSummary) => {
				this.rating = reviewSummary.averageRating ?? 0;
				this.count = reviewSummary.reviewCount ?? 0;
				this.reviewSummary = reviewSummary;
			});
	}

	ngOnDestroy() {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}
}
